//
// Shop: Search
//

"use strict";

( function($, waTheme) {

    var FixedHeader = (function ($) {

        FixedHeader = function (options) {
            var that = this;

            // DOM
            that.$window = $(window);
            that.$wrapper = options["$wrapper"];

            // VARS
            that.showClass = "show";
            that.scrollTop = 450;

            // INIT
            that.bindEvents();
        };

        FixedHeader.prototype.bindEvents = function () {
            var that = this;

            that.$window.scroll(function () {
                if (that.$window.scrollTop() > that.scrollTop) {
                    that.$wrapper.addClass(that.showClass);
                } else {
                    that.$wrapper.removeClass(that.showClass);

                    // hide all dropdowns
                    that.$wrapper.find(".dropdown-menu").dropdown("hide");
                }
            });
        };

        return FixedHeader;

    })($);

    waTheme.init.shop.FixedHeader = FixedHeader;

    var $wrapper = $('.l-desktop-header--fixed');
    if ($wrapper.length) {
        new window.waTheme.init.shop.FixedHeader({
            $wrapper: $wrapper,
        });
    }

})(jQuery, window.waTheme);
